import { createOptionCategoryItem, deleteOptionCategory } from '../../apis/backend'
import { sortItemsPositionForShop, setCopyKey } from '../../utils/product'
import { ERROR_DELETE_OPTION, ERROR_DUPLICATION, ERROR_SYNCHRONIZATION_WITH_SHOP } from '../../constants'
import { isObjectNotEmpty, keyGenerator } from '../../utils/tools'
import _ from 'lodash'
import { getShopsToSynchronise } from '../../utils/shopUtils'
import { checkAccess } from 'src/utils/admins'

export const showDeleteOptionModal = (option, component) => {
  const { showModal, shopId, shops, nbShops } = component.props;
  const nbShopsToSync = _.size(getShopsToSynchronise())
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer ${option.name} ?`,
    showCancelBtn: true,
    checkboxes: nbShops > 1 && nbShopsToSync > 1 && checkAccess('features', 'globalProduct') ?
      [{
        text: 'Supprimer cette option sur un ou plusieurs magasins',
        onChange: checked => {
          component.setState({ synchronize: checked });
        }
      }] : [],
    btnColor: 'danger',
    onClick: () => {
      component.state.synchronize && nbShops > 1 && nbShopsToSync > 1 ?
        component.setState({
          selectedShops: { [shopId]: shops[shopId] },
          showModal: true,
          option
        }) :
        handleRemoveOption(option, component);
      showModal({
        ...modalData,
        loading: true
      });
      (!component.state.synchronize) && component.setState({ synchronize: false, showModal: false });
    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
}

export const handleRemoveOption = async (option, component) => {
  const { categoryKey, openErrorModal, showModal } = component.props;
  const { selectedShops, synchronize } = component.state;
  try {
    showModal({
      color: 'danger',
      title: `Êtes-vous sûr(e) de vouloir supprimer ${option.name} ?`,
      loading: true
    });
    if (!synchronize || (synchronize && _.size(selectedShops) > 1)) {
      component.setState({ isLoading: true })
      await deleteOptionCategory(categoryKey, synchronize, selectedShops, option.key);
      component.setState({ option: {}, showModal: false, selectedShops: {}, isLoading: false })
      showModal(null);
    }
    else openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP);


  } catch (error) {
    openErrorModal(ERROR_DELETE_OPTION);
    await component.setState({ showModal: false });
  }
  await component.setState({ isLoading: false });
  showModal(null);
}

export const handleDuplicateOption = async (option, component) => {
  const { openErrorModal, categoryKey } = component.props;
  try {
    const key = setCopyKey(keyGenerator('ITEM'));
    const { name, position, price, ref } = option;
    const newItem = {
      ...option,
      name,
      position,
      price,
      ref,
      key
    }
    await createOptionCategoryItem(categoryKey, newItem);
  } catch (error) {
    openErrorModal(ERROR_DUPLICATION);
  }
  component.setState({ selectedShops: {} })
};

export const handleOpenModal = (option = {}, component) =>
  component.setState({
    showOptionModal: true,
    createOption: !isObjectNotEmpty(option),
    option
  })

export const closeModal = component => {
  component.setState({ showOptionModal: false, option: {}, synchronize: false });
}

export const handleDragOption = async (event, options, component) => {
  const { categoryKey = '' } = component.props;
  const { active, over } = event;
  if (active.id !== over.id) {
    component.setState({
      isSorting: true
    });
    await sortItemsPositionForShop(event, options, categoryKey, true);
    component.setState({
      isSorting: false,
      activeId: null
    });

  }
}

export const handleStartDrag = (event, component) => {
  component.setState({ activeId: event.active.id });
}
